import { Flex, Skeleton } from '@optiaxiom/react';

export function AgentDetailsSidebarSkeleton() {
  return (
    <Flex flexDirection="column" h="full">
      {/* Main Content */}
      <Flex flexDirection="column" gap="16" p="24" flex="1" overflow="auto">
        {/* Header */}
        <Flex flexDirection="row" justifyContent="space-between" alignItems="start">
          <Flex flexDirection="row" alignItems="start" gap="12">
            <Skeleton w="40" h="40" rounded="md" />
            <Flex flexDirection="column" gap="0">
              <Skeleton w="224" h="24" />
              <Skeleton w="2/3" h="20" />
            </Flex>
          </Flex>
          <Skeleton w="32" h="32" />
        </Flex>

        {/* Description */}
        <Flex flexDirection="column" gap="8">
          <Flex flexDirection="column" gap="4">
            <Skeleton w="full" h="16" />
            <Skeleton w="full" h="16" />
            <Skeleton w="3/4" h="16" />
          </Flex>
        </Flex>

        {/* View Documentation Link */}
        <Flex flexDirection="row" alignItems="center" gap="12" py="8">
          <Skeleton w="1/3" h="16" />
        </Flex>

        {/* Tags and Tools Section */}
        <Flex flexDirection="column" gap="8" w="full">
          {/* Tags */}
          <Flex flexDirection="row" gap="8" alignItems="center" w="full">
            <Skeleton w="16" h="16" />
            <Flex flexDirection="row" gap="8" flexWrap="nowrap" flex="1" overflow="hidden">
              <Skeleton w="80" h="24" rounded="full" />
              <Skeleton w="64" h="24" rounded="full" />
              <Skeleton w="48" h="24" rounded="full" />
            </Flex>
          </Flex>
          {/* Tools */}
          <Flex flexDirection="row" gap="8" alignItems="center" w="full">
            <Skeleton w="16" h="16" />
            <Flex flexDirection="row" gap="8" flexWrap="nowrap" flex="1" overflow="hidden">
              <Skeleton w="80" h="24" rounded="full" />
              <Skeleton w="80" h="24" rounded="full" />
            </Flex>
          </Flex>
        </Flex>

        {/* Installation Options */}
        <Flex flexDirection="column" gap="8" pt="16">
          <Skeleton w="1/3" h="16" />
          <Skeleton w="3/4" h="20" />
        </Flex>
      </Flex>

      {/* Footer */}
      <Flex
        flexDirection="row"
        justifyContent="flex-end"
        alignItems="center"
        gap="8"
        p="24"
        pt="16"
      >
        <Skeleton w="1/3" h="32" />
        <Skeleton w="64" h="32" />
      </Flex>
    </Flex>
  );
}
